import type { CustomOrgRolePermission } from '@nadoutong/contracts';
import type { I18nKey } from '../../i18n/index.ts';

export interface OrgRolePermissionItem {
  readonly id: CustomOrgRolePermission;
  readonly labelKey: I18nKey;
}

export interface OrgRolePermissionGroup {
  readonly id: string;
  readonly labelKey: I18nKey;
  readonly permissions: readonly OrgRolePermissionItem[];
}

/**
 * Grouped plain-language labels for the closed `org:*` checklist.
 * Groups follow the sidebar menu: usage/request logs, billing, keys,
 * members, then audit and export which have no nav row. `member:*` is
 * not a combinable option.
 */
export const ORG_ROLE_PERMISSION_GROUPS: readonly OrgRolePermissionGroup[] = [
  {
    id: 'usage',
    labelKey: 'organization.roles.group.usage',
    permissions: [{ id: 'org:usage:read', labelKey: 'organization.roles.perm.usage_read' }],
  },
  {
    id: 'billing',
    labelKey: 'organization.roles.group.billing',
    permissions: [
      { id: 'org:billing:read', labelKey: 'organization.roles.perm.billing_read' },
      { id: 'org:billing:manage', labelKey: 'organization.roles.perm.billing_manage' },
    ],
  },
  {
    id: 'keys',
    labelKey: 'organization.roles.group.keys',
    permissions: [
      { id: 'org:api_keys:read', labelKey: 'organization.roles.perm.api_keys_read' },
      { id: 'org:api_keys:manage', labelKey: 'organization.roles.perm.api_keys_manage' },
    ],
  },
  {
    id: 'members',
    labelKey: 'organization.roles.group.members',
    permissions: [
      { id: 'org:members:read', labelKey: 'organization.roles.perm.members_read' },
      { id: 'org:members:manage', labelKey: 'organization.roles.perm.members_manage' },
      { id: 'org:invitations:manage', labelKey: 'organization.roles.perm.invitations_manage' },
    ],
  },
  {
    id: 'audit',
    labelKey: 'organization.roles.group.audit',
    permissions: [{ id: 'org:audit:read', labelKey: 'organization.roles.perm.audit_read' }],
  },
  {
    id: 'reports',
    labelKey: 'organization.roles.group.reports',
    permissions: [{ id: 'org:reports:export', labelKey: 'organization.roles.perm.reports_export' }],
  },
];
